import { defineMessages } from 'react-intl';

export default defineMessages({
    account: {
        id: 'gateway.views.quote-detail.Account',
        defaultMessage: 'Account',
    },
    activities: {
        id: 'gateway.views.quote-detail.Activities',
        defaultMessage: 'Activities',
    },
    continueQuote: {
        id: 'gateway.views.quote-detail.Continue Quote',
        defaultMessage: 'Continue Quote',
    },
    createdDate: {
        id: 'gateway.views.policy-detail-summary.Created Date',
        defaultMessage: 'Created Date',
    },
    documents: {
        id: 'gateway.views.quote-detail.Documents',
        defaultMessage: 'Documents',
    },
    effectiveDate: {
        id: 'gateway.views.quote-detail.Effective Date',
        defaultMessage: 'Effective Date',
    },
    note: {
        id: 'gateway.views.quote-detail.Note',
        defaultMessage: 'Note',
    },
    notes: {
        id: 'gateway.views.quote-detail.Notes',
        defaultMessage: 'Notes',
    },
    openActivities: {
        id: 'gateway.views.quote-detail.Open Activities',
        defaultMessage: 'Open Activities',
    },
    openIssues: {
        id: 'gateway.views.quote-detail.Open Issues',
        defaultMessage: 'Open UW Issues',
    },
    policy: {
        id: 'gateway.views.quote-detail.Policy',
        defaultMessage: 'Policy',
    },
    premium: {
        id: 'gateway.views.quote-detail.Premium',
        defaultMessage: 'Premium',
    },
    status: {
        id: 'gateway.views.policy-detail-summary.Status',
        defaultMessage: 'Status',
    },
    summary: {
        id: 'gateway.views.quote-detail.Summary',
        defaultMessage: 'Summary',
    },
    premiumQuoteCalculated: {
        id: 'gateway.views.quote-detail.Premium for this quote has been calculated.',
        defaultMessage: 'Premium for this quote has been calculated.',
    },
    premiumQuoteCalculatedTWIA: {
        id: 'gateway.views.quote-detail.This quote has not been submitted.',
        defaultMessage: 'This quote has not been submitted.',
    },
    quoteHasBeenBound: {
        id: 'gateway.views.quote-detail.This quote has been bound',
        defaultMessage: 'This quote has been bound',
    },
    quoteSuccessfullyStarted: {
        id: 'gateway.views.quote-detail.This quote has been successfully started',
        defaultMessage: 'This quote has been successfully started.',
    },
    quoteOfferSubmitted: {
        id: 'gateway.views.quote-detail.Offer has been submitted.',
        defaultMessage: 'Offer has been submitted.',
    },
    quoteOfferSubmittedViewDocs: {
        id: 'gateway.views.quote-detail.You can access the Offer document in the Documents section.',
        defaultMessage: 'You can access the Offer document in the Documents section.',
    },
    quoteNotTaken: {
        id: 'gateway.views.quote-detail.This quote has been closed as Not Taken.',
        defaultMessage: 'This quote has been closed as Not Taken.',
    },
    quoteDeclinedMessage: {
        id: 'gateway.views.quote-detail.This quote has been declined for the following reason:',
        defaultMessage: 'This quote has been declined for the following reason:',
    },
    expiredQuoteMessage: {
        id: 'gateway.views.quote-detail.This quote has expired.',
        defaultMessage: 'This quote has expired.',
    },
    quoteSuccessfullyStartedTwia: {
        id: 'gateway.views.quote-detail.This quote has not been submitted',
        defaultMessage: 'This quote has not been submitted',
    },
    thisQuoteHasBeenWithDrawn: {
        id: 'gateway.views.quote-detail.This quote has been withdrawn',
        defaultMessage: 'This quote has been withdrawn.',
    },
    withdrawQuote: {
        id: 'gateway.views.quote-detail.WithdrawQuote',
        defaultMessage: 'Withdraw Quote',
    },
    continiueQuoteQizard: {
        id: 'gateway.views.quote-detail.You may either continue the quote or withdraw it.',
        defaultMessage:
            'You may either continue the quote or withdraw it.',
    },
    changeQuoteWizardToBind: {
        id: 'gateway.views.quote-detail.You may either continue the quote or withdraw it.',
        defaultMessage:
            'You may either continue the quote or withdraw it.',
    },
    mayWithdrawQuote: {
        id: 'gateway.views.quote-detail.You may withdraw the quote',
        defaultMessage: 'You may withdraw the quote',
    },
    sureWithDrawQuote: {
        id: 'gateway.directives.JobSummary.Are you sure you want to withdraw quote:',
        defaultMessage: 'Are you sure you want to withdraw quote:',
    },
    failedWithdrawSubmission: {
        id: 'gateway.directives.JobSummary.Failed to withdraw submission',
        defaultMessage: 'Failed to withdraw submission',
    },
    withdraw: {
        id: 'gateway.directives.JobSummary.Withdraw',
        defaultMessage: 'Withdraw',
    },
    withdrawJob: {
        id: 'gateway.directives.JobSummary.WithdrawJob',
        defaultMessage: 'Withdraw Quote?',
    },
    errorDescription: {
        id: 'gateway.directives.JobSummary.error.create.submission.insufficient-permission',
        defaultMessage: 'This agency or user does not have permission to initiate or process this transaction.'
    }
});
